module.exports = __webpack_public_path__ + "img/CHOICE_tc.6bfa67fa.png";